import { render, staticRenderFns } from "./TwofaForm.vue?vue&type=template&id=b74b2522"
import script from "./TwofaForm.vue?vue&type=script&lang=js"
export * from "./TwofaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports